import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "app/rootReducer";

import { UserState } from "./userSlice";

function getUser(state: RootState): UserState {
  return state.user;
}

export const selectUserProfile = createSelector(getUser, user => user.current);
export const selectThirdPartyAuthStatus = createSelector(getUser, user => user.thirdPartyAuthStatus);
export const selectUserCreatedInSession = createSelector(getUser, user => user.userCreatedInSession);
